import {
    getFirestore,
    getDoc,
    doc
} from "firebase/firestore";
const getOrgList = async function (id) {
    if (id == null || id == undefined) {
        return 0;
    }
    let db = getFirestore();
    let ref = doc(db, "wellness_org", id);
    const docSnapa = await getDoc(ref);
    return {
        ...docSnapa.data(),
        ...{
            id: docSnapa.id
        }
    };
};
export default getOrgList;